export default function TransferVerticalIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.00024 4.58545L4.00024 8.58545V10.0005H5.41431L7.00024 8.41455V17.0005H9.00024V8.41455L10.5862 10.0005H12.0002V8.58643L8.00024 4.58545ZM20.0002 14.0005H18.5862L17.0002 15.5864V7.00049H15.0002V15.5864L13.4143 14.0005H12.0002V15.4146L16.0002 19.4146L20.0002 15.4146V14.0005Z"
        fill="var(--text-secondary-color)"
      />
    </svg>
  );
}
